import { Grid, Paper } from "@mui/material";
import React from "react";
import MainMenu from "../../../components/MainMenu";
import LeaderboardList from "../../../components/LeaderboardComponents/LeaderboardList";
import LeaderboardPOTYList from "../../../components/LeaderboardComponents/LeaderboardPOTYList";

const index = () => {
  return (
    <MainMenu>
      <Grid container>
        <Grid item xs={12}>
          <Paper elevation={3}>
            {/* <SeasonList /> */}
            {/* <LeaderboardList /> */}
            <LeaderboardPOTYList />
          </Paper>
        </Grid>
      </Grid>
    </MainMenu>
  );
};

export default index;
